import axios from 'axios';

import { URL, API_KEY } from '~/common/helpers/environment';

type ReportParams = {
  realm: string;
  stage: string;
  action: string;
  message: string;
};

const clientDiagnostics = {
  report({ realm, ...body }: ReportParams) {
    return axios.post(
      `${URL}/${encodeURIComponent(realm)}/client-diagnostics`,
      body,
      {
        headers: {
          'Content-Type': 'application/json',
          apikey: API_KEY
        }
      }
    );
  }
};

export default clientDiagnostics;
